import get from 'lodash/get';
import { CLEAR_RECOGNITION } from 'app/app-dux/recognition-dux';

/*******************************************************************************
 * Initial state
 */
const initialState = {
	message: '',
	selectedEcard: {},
	visibility: 'public'
};

/*******************************************************************************
 * Non-async action types
 */
export const SET_MESSAGE = 'setState_SET_MESSAGE';
export const SET_VISIBILITY = 'setState_SET_VISIBILITY';
export const SET_SELECTED_ECARD = 'setState_SET_SELECTED_ECARD';

/*******************************************************************************
 * Reducer
 */
export default function messageReducer( state = initialState, action ) {
	switch ( action.type ) {
		case SET_MESSAGE: {
			return {
				...state,
				message: action.message
			};
		}
		case SET_SELECTED_ECARD: {
			return {
				...state,
				selectedEcard: action.ecard
			};
		}
		case SET_VISIBILITY: {
			return {
				...state,
				visibility: action.visibility.toLowerCase()
			};
		}
		case CLEAR_RECOGNITION: {
			return initialState;
		}
		default:
			return state;
	}
}

/*******************************************************************************
 * Action creators
 */
export const setMessage = message => ( { type: SET_MESSAGE, message } );
export const setSelectedEcard = ecard => ( { type: SET_SELECTED_ECARD, ecard } );
export const setVisibility = ( visibility ) => ( { type: SET_VISIBILITY, visibility } );

// selectors
export const getMessage = state => get( state, 'message.message', '' );
export const getVisibility = state => get( state, 'message.visibility', 'public' );
export const getSelectedEcard = state => get( state, 'message.selectedEcard' );